export enum AlertBadgeType {
  Critical = 'critical',
  Warning = 'warning',
  Info = 'info',
}
